:host {
  display: inline-flex;
  /** @prop --icon-color: Set the color of the <anchor-icon> */
  --icon-color: currentColor;
}

:host .anchor-c-icon {
  width: var(--size);
  height: var(--size);
  display: inline-block;
}

:host .anchor-c-icon svg {
  width: 100%;
  height: 100%;
  stroke: var(--icon-color);
  stroke-width: var(--stroke);
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

:host .anchor-c-icon--fill svg {
  fill: var(--icon-color);
}

:host svg,
:host svg * {
  stroke-width: var(--stroke);
  stroke-linecap: var(--cap);
  stroke-linejoin: var(--join);
}
